<template>
  <div id="app">
    <keep-alive>
      <router-view class="routerContent" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 没有缓存 -->
    <router-view class="routerContent" v-if="!$route.meta.keepAlive"></router-view>
    <router-view name="tabbar"></router-view>
  </div>
</template>

<script>
import { Toast } from "vant";
import useApi from '@/api/auth'
import { fstEncrypt,fstDecrypt } from '@/utils/cryptojs';
import axios from 'axios'
export default {
  name: 'App',

  onLoad() {
  },
  created() {
    document.title = this.GlobalteamName;
   
  },
  computed: {

  },

  mounted() {
    window['getUserMessage'] = (callback) => {
      console.log(callback)
    }
    this.onHandleVuexInfo()
  },
  methods: {
      //响应加密返回列表 这个接口必须加密前后端约好的
    onHandleVuexInfo() {
      var urllink = 'https://gateway2.fst1994.net' // 线上接口
      // var urllink = "http://192.168.5.203:21020"; // 测试接口
      axios({
        method: 'post',
        url: `${urllink}/v2/api/app/ad_user//encrypt/config/get/list/appD?appName=${this.appName}`,
        headers: { 'Content-Type': 'application/json', },
      }).then((res) => {
        if (res.data.success) {
          let localDecrypt = res.data.data
          if (localDecrypt&&localDecrypt.length) {
            window.localStorage.localDecrypt = localDecrypt
            this.$store.dispatch('localDecrypt', window.localStorage.localDecrypt)
          }
          this.getencryptList()
          this.getresourceApi()
        }
      })

    },
        //获取获取资源key   判断获取资源key 表接口在不在响应列表中，不在返回值进行加密 在直接存储返回值
    getresourceApi() {
      let params = {
        appName: this.appName
      }
      useApi.getresource(params).then((res) => {
        if (res.success) {
          let allRresource = res.data
          window.localStorage.allRresource = fstEncrypt(JSON.stringify(allRresource), this.$store.state.$aesKey, this.$store.state.$aesIv)
       // console.log("====资源加密后数据=====", window.localStorage.allRresource, "======data===", res.data)      
        } else {
          Toast.fail(res.message)
        }
      })
    },
    //获取请求加密列表  判断请求加密列表接口在不在响应列表中，不在返回值进行加密 在直接存储返回值
    getencryptList() {
      let params = {
        appName: this.appName
      }
      useApi.encryptList(params).then((res) => {
        if (res.success) {
          let localEncrypt = res.data
          if(localEncrypt&&localEncrypt.length){
            let fstEncryptData = fstEncrypt(JSON.stringify(localEncrypt), this.$store.state.$aesKey, this.$store.state.$aesIv)
              window.localStorage.localEncrypt  = fstEncryptData
            this.$store.dispatch('localEncrypt', fstEncryptData)
        }
          // console.log("====localEncrypt=====",window.localStorage.localEncrypt)
        } else {
          Toast.fail(res.message)
        }
      })
    },
  }
}
</script>

<style>
/* @font-face {
		font-family:"微软雅宋"; 
		src: url("./assets/ttf/FZBIAOYSJW.TTF");
	} */
* {
  margin: 0;
  padding: 0;
}

a {
  color: #424242;
}

li {
  list-style: none;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}

html {
  -webkit-overflow-scrolling: touch;
}

/* html {
		height: 100%;
	} */
body {
  /* max-width: 700px; */
  overflow-x: hidden;
  background: #f1f1f1;
  /* margin: 0 auto!important; */
}

body,
html {
  width: 100%;
  height: 100%;
}

#app {
  font-family: "微软雅宋";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.2rem;
  width: 100%;
  height: 100%;
  color: #333333;
  background: #fff;
  margin: 0px auto;
  /* max-width: 700px; */
}

.routerContent {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /* padding-bottom: 50px; */
  box-sizing: border-box;
}

.outerFrame {
  height: calc(100% - 0.5rem);
}

.titlesTop {
  padding-top: 44px;
  box-sizing: border-box;
}
</style>
